import { forwardRef } from 'react';

import Button from '@/components/common/Button';
import { useTranslate } from '@/hooks/useTranslate';
import { t } from '@/utils/helper/intl';

import ErrorIcon from './icon/error';

export interface UploadErrorProps {
  slotNode?: (onReUpload: () => void) => React.ReactNode;
  onReUpload: () => void;
}

const UploadError = forwardRef<HTMLDivElement, UploadErrorProps>(
  (props, ref): React.ReactNode => {
    const { slotNode, onReUpload } = props;

    return (
      <div ref={ref} className={`wrapper-upload-step w-full h-full`}>
        {slotNode ? (
          slotNode(onReUpload)
        ) : (
          <div className="w-full h-full flex flex-col justify-center items-center gap-[12px]">
            <ErrorIcon />

            <Button
              className={`!text-[13px] !w-[100px] !h-[32px]`}
              onClick={(e) => {
                e && e.stopPropagation();
                onReUpload();
              }}
            >
              {t('merror.upload.reUploadTip')}
            </Button>
          </div>
        )}
      </div>
    );
  },
);

export default UploadError;
